import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Create a custom tailwind-merge instance that knows about our custom text utilities
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-h1',
        'text-h2',
        'text-h3',
        'text-h4',
        'text-h5',
        'text-p1',
        'text-p1-mono',
        'text-p2',
        'text-p2-mono',
        'text-p3',
        'text-p3-mono',
        'text-p4',
        'text-p4-mono',
        'text-eyebrow',
        'text-eyebrow-sm',
      ],
      'bg-image': ['bg-select-field', 'bg-checkbox-field'],
    },
  },
});

export default function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
